export default __webpack_public_path__ + "static/media/airdome-dead.fc7388d5.svg";